// Copyright (c) 2016 Deere & Company

import MaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/maintenance-plan-report';
import t from 'tcomb';

const Report = t.list(MaintenancePlan, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/report.js